/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action, computed } from '@ember/object';
import Component from '@glimmer/component';
import { ActionTypeItem } from 'cio/utils/action-info';
import { dasherize } from '@ember/string';
import { typeOf } from '@ember/utils';
import CampaignModel from 'cio/models/campaign';
import { AddActionsPanelItemConfig } from 'cio/utils/visual-workflow-builder/add-actions-panel';
import { inject as service } from '@ember/service';
import AccountService from 'cio/services/account';
import { bool } from '@ember/object/computed';
import AuthService from 'cio/services/auth';

interface AddActionsPanelItemArgs {
  item: ActionTypeItem;
  campaign: CampaignModel;
  canDrag: boolean;
  onDragStart: () => unknown;
  config?: AddActionsPanelItemConfig;
}

export default class AddActionsPanelItem extends Component<AddActionsPanelItemArgs> {
  @service account!: AccountService;
  @service auth!: AuthService;

  @bool('account.current.suspendTrialAt') isEssentialsTrial!: boolean;

  draggablePluginOptions = {
    clone: {
      appendContainer: 'body',
    },
    autoscroll: {
      scrollableElement: '.js-vwb-canvas',
    },
  };

  @computed('args.item.enabled')
  get showEnabled() {
    return this.args.item.enabled;
  }

  @computed('args.item.info.name')
  get identifierClassName() {
    if (this.args.item?.info != null) {
      let identifier = dasherize(this.args.item.info.shortName.replace(/[^a-zA-Z]/g, ''));
      return `vwb-add-actions-panel-item__${identifier}`;
    }

    return '';
  }

  get name() {
    if (
      this.args.item.info.addActionsPanelName != null &&
      typeOf(this.args.item.info.addActionsPanelName) === 'function'
    ) {
      return this.args.item.info.addActionsPanelName(this.args.campaign);
    }

    return this.args.item.info.name;
  }

  get config() {
    return this.args.config ?? {};
  }

  @action
  handlePremiumActionClick(popoverOpen: () => unknown) {
    if (!this.shouldDisplayGatedFeaturesPopover) {
      return;
    }

    popoverOpen();
  }

  get isItemPremiumFeature() {
    return this.args.item.info.isPremiumFeature ?? false;
  }

  get showActionNotEnabledTooltip() {
    return !this.showEnabled && !this.isItemPremiumFeature;
  }

  get showPremiumFeatureLabel() {
    return this.isItemPremiumFeature && this.account.planFeatures.collections.showPremiumLabel;
  }

  get shouldDisplayGatedFeaturesPopover() {
    return this.isItemPremiumFeature && !this.account.planFeatures.collections.enabled;
  }

  get cursorClass() {
    if (!this.showEnabled) {
      if (this.shouldDisplayGatedFeaturesPopover) {
        return 'cursor-pointer';
      }
      return 'cursor-default';
    }
    return '';
  }
}
